import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PlaybackFastForward.svg",
  "use": "PlaybackFastForward.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PlaybackFastForward.svg\"><path d=\"M34.9987,19.3057,52.9919,30.2262a2.12,2.12,0,0,1,0,3.5874l-17.9932,10.92A1.9968,1.9968,0,0,1,31.9973,42.94V34.4174L14.9987,44.7341A1.9968,1.9968,0,0,1,11.9973,42.94V21.0994a1.9967,1.9967,0,0,1,3.0014-1.7937L31.9973,29.6226V21.0994A1.9967,1.9967,0,0,1,34.9987,19.3057Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol